import React, { useState, useRef, forwardRef } from 'react'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import theme from '../../theme'
import Button from '@mui/material/Button'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import Switch from '@mui/material/Switch'
import Divider from '@mui/material/Divider'
import CreationName from './CreationName'
import Dialog from '../../UI/Dialog.js'
import { useOutletContext } from 'react-router-dom'
import { CSSTransition } from 'react-transition-group'
import { useMediaQuery } from 'react-responsive'
import 'animate.css'
import classes from './CreationShape.module.css'

// prepare the function to forward the ref (will be necessary pass the ref as a props to the input of the name in CreationName)
const CreationNameRef = forwardRef(function CreationNameRef(props, ref) {
  return <CreationName forwardedRef={ref} />
})

const Creation = (props) => {
  const cellsAmount = 49
  let randomColor
  let tempRandomColor
  let randomValue
  let colorCells = []
  let colorInTheGrid = []
  let cells = []
  let cellsInTheGrid = []
  let autoDiv = []
  let checkTrulyCellInTheGrid
  let centralCellAllowed = [3, 10, 17, 24, 31, 38, 45]
  let cellAllowedLeft = [
    0,
    1,
    2,
    7,
    8,
    9,
    14,
    15,
    16,
    21,
    22,
    23,
    28,
    29,
    30,
    35,
    36,
    37,
    42,
    43,
    44,
  ]
  // media conditional component
  const isDesktopOrMobile = useMediaQuery({
    query: '(min-width: 871px)',
  })

  // starting functions for initial useState
  const startingColorCells = [
    'leftRight',
    0,
    6,
    'central',
    3,
    'leftRight',
    8,
    12,
    'leftRight',
    9,
    11,
    'leftRight',
    14,
    20,
    'leftRight',
    16,
    18,
    'central',
    17,
    'central',
    24,
    'leftRight',
    29,
    33,
    'leftRight',
    30,
    32,
    'leftRight',
    36,
    40,
    'leftRight',
    44,
    46,
  ]
  const startingColorInTheGrid = [
    classes.randomColor1A,
    '',
    '',
    classes.randomColor0A,
    '',
    '',
    classes.randomColor1A,
    '',
    classes.randomColor0A,
    classes.randomColor2A,
    '',
    classes.randomColor2A,
    classes.randomColor0A,
    '',
    classes.randomColor1A,
    '',
    classes.randomColor0A,
    classes.randomColor3A,
    classes.randomColor0A,
    '',
    classes.randomColor1A,
    '',
    '',
    '',
    classes.randomColor2A,
    '',
    '',
    '',
    '',
    classes.randomColor3A,
    classes.randomColor0A,
    '',
    classes.randomColor0A,
    classes.randomColor3A,
    '',
    '',
    classes.randomColor1A,
    '',
    '',
    '',
    classes.randomColor1A,
    '',
    '',
    '',
    classes.randomColor0A,
    '',
    classes.randomColor0A,
    '',
    '',
  ]
  const startingCells = [
    true,
    false,
    false,
    true,
    false,
    false,
    true,
    false,
    true,
    true,
    false,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    true,
    false,
    true,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    true,
    true,
    false,
    true,
    true,
    false,
    false,
    true,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    true,
    false,
    true,
    false,
    false,
  ]

  // handling for the form button
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  // get the date and push it as a value in the database
  const date = new Date()
  const today =
    date.getDate() +
    '/' +
    (date.getMonth() + 1) +
    '/' +
    date.getFullYear() +
    ' ' +
    date.getHours() +
    ':' +
    String(date.getMinutes()).padStart(2, '0')

  // filter and remove string from array
  function filter_list(l) {
    return l.filter((x) => typeof x === 'number')
  }

  // random function for select the cells
  function getRandomInt(max) {
    return Math.floor(Math.random() * max)
  }

  // get specular number (cell) in the grid
  function specularNumber(n) {
    const diff = n - parseInt(n / 7) * 7
    return parseInt(n / 7) * 7 + 6 - diff
  }

  // check radio button
  const [checked, setChecked] = useState(false)
  const handleSwitch = (e) => {
    setChecked(e.target.checked)
  }
  const nodeRefColorSet = useRef(null)
  const nodeRefDivider = useRef(null)

  /////////////

  const [stateCellsGrid, setStateCellsGrid] = useState(startingCells)
  const [statePreColorGrid, setStatePreColorGrid] = useState(startingColorCells)
  const [stateColorGrid, setStateColorGrid] = useState(startingColorInTheGrid)
  const [firstRun, setFirstRun] = useState(true)
  const [firstColorRun, setFirstColorRun] = useState(true)

  const colorPresetA = [
    classes.randomColor0A,
    classes.randomColor1A,
    classes.randomColor2A,
    classes.randomColor3A,
  ]
  const colorPresetB = [
    classes.randomColor0B,
    classes.randomColor1B,
    classes.randomColor2B,
    classes.randomColor3B,
  ]
  const colorPresetC = [
    classes.randomColor0C,
    classes.randomColor1C,
    classes.randomColor2C,
    classes.randomColor3C,
  ]
  const colorPresetD = [
    classes.randomColor0D,
    classes.randomColor1D,
    classes.randomColor2D,
    classes.randomColor3D,
  ]

  const nameRef = useRef('')
  const shapeRef = useRef('') //startinCells
  const colorRef = useRef('') //startingColorInTheGrid
  const coloSetRef = useRef('')
  const dateRef = useRef('')

  // submit function
  const context = useOutletContext()

  function submitHandler(event) {
    event.preventDefault()

    if (firstColorRun === false) {
      shapeRef.current = startingCells
      dateRef.current = today
    }
    if (firstRun === true && firstColorRun === true) {
      shapeRef.current = startingCells
      colorRef.current = startingColorInTheGrid
      coloSetRef.current = 1
      dateRef.current = today
    }

    const data = {
      name: nameRef.current.value,
      shape: shapeRef.current,
      color: colorRef.current,
      colorSet: coloSetRef.current,
      date: dateRef.current,
    }

    dateRef.current = today
    context.onAddInvader(data)
    handleClickOpen()
  }

  const [colorPreset, setColorPreset] = useState(colorPresetA)
  const [colorSet, setColorSet] = useState(1)
  function handleColorPreset(e) {
    if (e.target.value === 'A') {
      setColorPreset(colorPresetA)
      setColorSet(1)
    }

    if (e.target.value === 'B') {
      setColorPreset(colorPresetB)
      setColorSet(2)
    }
    if (e.target.value === 'C') {
      setColorPreset(colorPresetC)
      setColorSet(3)
    }
    if (e.target.value === 'D') {
      setColorPreset(colorPresetD)
      setColorSet(4)
    }
  }
  // randomize color function
  function setRandomColor(x) {
    switch (x) {
      case 0:
        randomColor = colorPreset[0]
        break
      case 1:
        randomColor = colorPreset[1]
        break
      case 2:
        randomColor = colorPreset[2]
        break
      case 3:
        randomColor = colorPreset[3]
        break
      default:
        randomColor = ''
    }
    return randomColor
  }

  // randomize set color
  function getColor(tempCell) {
    setFirstColorRun(false)
    for (var k = 0; k < tempCell.length; k++) {
      if (tempCell[k] === 'central') {
        tempRandomColor = setRandomColor(getRandomInt(4))
        colorCells.push(tempRandomColor)
      }
      if (tempCell[k] === 'leftRight') {
        tempRandomColor = setRandomColor(getRandomInt(4))
        colorCells.push(tempRandomColor)
        colorCells.push(tempRandomColor)
      }
    }
    for (var h = 0; h < cellsAmount; h++) {
      if (filter_list(tempCell).includes(h)) {
        colorInTheGrid.push(colorCells[filter_list(tempCell).indexOf(h)])
      } else {
        colorInTheGrid.push('')
      }
    }
    setStateColorGrid(colorInTheGrid)
    colorRef.current = colorInTheGrid // prepare the ref

    coloSetRef.current = colorSet
  }

  // randomize composition of the grid (by clicking randomize shape)
  const getShape = () => {
    setFirstRun(false)
    for (var i = 0; i < cellsAmount; i++) {
      randomValue = getRandomInt(3)
      if (randomValue === 0 && cellAllowedLeft.includes(i)) {
        cells.push('leftRight') // this is a boundary for the colors (left and right share the same color, contrary to the central ones)
        cells.push(i)
        cells.push(specularNumber(i))
      }
      if (getRandomInt(3) === 0 && centralCellAllowed.includes(i)) {
        cells.push('central')
        cells.push(i)
      }
      // creating a grid determining blank and filled cells
      if (cells.includes(i)) {
        cellsInTheGrid.push(true)
      } else {
        cellsInTheGrid.push(false)
      }
    }
    setStateCellsGrid(cellsInTheGrid)
    setStatePreColorGrid(cells)
    getColor(cells)
    shapeRef.current = cellsInTheGrid // prepare the ref
  }

  // put together results of getShape and getColor
  function getTotalGrid(shape, color) {
    for (var j = 0; j < shape.length; j++) {
      checkTrulyCellInTheGrid = shape[j] === true
      autoDiv.push(
        <div
          className={
            classes.divBox + ' ' + checkTrulyCellInTheGrid + ' ' + color[j]
          }
          key={j}
        ></div>,
      )
    }
    return autoDiv
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <form onSubmit={submitHandler}>
          {/* receive the ref throw the forwardRed as a function (created previously) */}
          {!isDesktopOrMobile && <CreationNameRef ref={nameRef} />}
          <div className={classes.container}>
            <div className={classes.midContainer}>
              <div className={classes.innerContainer}>
                {getTotalGrid(stateCellsGrid, stateColorGrid)}
              </div>
              <div className={classes.controlArea}>
                {isDesktopOrMobile && <CreationNameRef ref={nameRef} />}

                <Button
                  // connect the ref of the function
                  ref={shapeRef}
                  onClick={() => getShape()}
                  className={classes.randomShapeButton}
                  variant="outlined"
                >
                  Randomize Shape
                </Button>
                <Button
                  // connect the ref of the function
                  ref={colorRef}
                  onClick={() => getColor(statePreColorGrid)}
                  className={classes.randomShapeButton}
                  variant="outlined"
                >
                  Randomize Color
                </Button>

                {!isDesktopOrMobile ? (
                  <div>
                    <div className={classes.containerSwitch}>
                      <div className={classes.switchNameDiv}>
                        Change color set
                      </div>
                      <Switch
                        onChange={handleSwitch}
                        className={classes.switch}
                      />
                    </div>

                    <Divider className={classes.divider} />
                    <CSSTransition
                      in={checked}
                      nodeRef={nodeRefColorSet}
                      timeout={600}
                      classNames={{
                        enter: classes.enterForm,
                        enterActive: classes.enterActiveForm,
                        enterDone: classes.enterDoneForm,
                        exit: classes.exitForm,
                        exitActive: classes.exitActiveForm,
                        exitDone: classes.exitDoneForm,
                      }}
                      unmountOnExit
                    >
                      <FormControl
                        ref={nodeRefColorSet}
                        className={classes.formControl}
                      >
                        <RadioGroup
                          color="primary"
                          aria-labelledby="radio-buttons-group-label"
                          defaultValue="A"
                          name="radio-buttons-group"
                          // value={value}
                          onChange={handleColorPreset}
                        >
                          <div className={classes.containerColor}>
                            <FormControlLabel
                              value="A"
                              control={<Radio />}
                              label="Set #1"
                            />
                            <span className={classes.containerColor}>
                              <div className={classes.singleColorA1}></div>
                              <div className={classes.singleColorA2}></div>
                              <div className={classes.singleColorA3}></div>
                              <div className={classes.singleColorA4}></div>
                            </span>
                          </div>
                          <div className={classes.containerColor}>
                            <FormControlLabel
                              value="B"
                              control={<Radio />}
                              label="Set #2"
                            />
                            <span className={classes.containerColor}>
                              <div className={classes.singleColorB1}></div>
                              <div className={classes.singleColorB2}></div>
                              <div className={classes.singleColorB3}></div>
                              <div className={classes.singleColorB4}></div>
                            </span>
                          </div>
                          <div className={classes.containerColor}>
                            <FormControlLabel
                              value="C"
                              control={<Radio />}
                              label="Set #3"
                            />
                            <span className={classes.containerColor}>
                              <div className={classes.singleColorC1}></div>
                              <div className={classes.singleColorC2}></div>
                              <div className={classes.singleColorC3}></div>
                              <div className={classes.singleColorC4}></div>
                            </span>
                          </div>
                          <div className={classes.containerColor}>
                            <FormControlLabel
                              value="D"
                              control={<Radio />}
                              label="Set #4"
                            />
                            <span className={classes.containerColor}>
                              <div className={classes.singleColorD1}></div>
                              <div className={classes.singleColorD2}></div>
                              <div className={classes.singleColorD3}></div>
                              <div className={classes.singleColorD4}></div>
                            </span>
                          </div>
                        </RadioGroup>
                      </FormControl>
                    </CSSTransition>
                    <CSSTransition
                      in={checked}
                      nodeRef={nodeRefDivider}
                      timeout={200}
                      classNames={{
                        enter: classes.enterDivider,
                        enterActive: classes.enterActiveDivider,
                        exit: classes.exitDivider,
                        exitActive: classes.exitActiveDivider,
                      }}
                      unmountOnExit
                    >
                      <Divider
                        ref={nodeRefDivider}
                        className={classes.movingDivider}
                      />
                    </CSSTransition>
                  </div>
                ) : (
                  <div>
                    <FormControl className={classes.formControl}>
                      <RadioGroup
                        color="primary"
                        aria-labelledby="radio-buttons-group-label"
                        defaultValue="A"
                        name="radio-buttons-group"
                        // value={value}
                        onChange={handleColorPreset}
                      >
                        <div className={classes.containerColor}>
                          <FormControlLabel
                            value="A"
                            control={<Radio />}
                            label="Set #1"
                          />
                          <span className={classes.containerColor}>
                            <div className={classes.singleColorA1}></div>
                            <div className={classes.singleColorA2}></div>
                            <div className={classes.singleColorA3}></div>
                            <div className={classes.singleColorA4}></div>
                          </span>
                        </div>
                        <div className={classes.containerColor}>
                          <FormControlLabel
                            value="B"
                            control={<Radio />}
                            label="Set #2"
                          />
                          <span className={classes.containerColor}>
                            <div className={classes.singleColorB1}></div>
                            <div className={classes.singleColorB2}></div>
                            <div className={classes.singleColorB3}></div>
                            <div className={classes.singleColorB4}></div>
                          </span>
                        </div>
                        <div className={classes.containerColor}>
                          <FormControlLabel
                            value="C"
                            control={<Radio />}
                            label="Set #3"
                          />
                          <span className={classes.containerColor}>
                            <div className={classes.singleColorC1}></div>
                            <div className={classes.singleColorC2}></div>
                            <div className={classes.singleColorC3}></div>
                            <div className={classes.singleColorC4}></div>
                          </span>
                        </div>
                        <div className={classes.containerColor}>
                          <FormControlLabel
                            value="D"
                            control={<Radio />}
                            label="Set #4"
                          />
                          <span className={classes.containerColor}>
                            <div className={classes.singleColorD1}></div>
                            <div className={classes.singleColorD2}></div>
                            <div className={classes.singleColorD3}></div>
                            <div className={classes.singleColorD4}></div>
                          </span>
                        </div>
                      </RadioGroup>
                    </FormControl>
                    <Divider ref={nodeRefDivider} className={classes.divider} />
                  </div>
                )}
                <div className={classes.containerSubmitButton}>
                  <Button
                    color="primary"
                    variant="outlined"
                    className={classes.submitButton}
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </form>
        <Dialog
          caughtError={context.caughtError}
          open={open}
          close={handleClose}
        />
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default Creation
